import React from 'react';
import PropTypes from 'prop-types';
import { Cushion, Grid, Rectangle, Shadow, Space, Typography } from '@pitchero/react-ui';
import Icon from '../icon';
import { Trans } from '../../lib/i18n';

const ScoreCardFallOfWickets = ({ fow }) => (
  <Space bottom="large">
    <Shadow>
      <Cushion
        all="small"
        left="medium"
        responsive={[{ maxWidth: 'tab', props: { left: 'small' } }]}
      >
        <Rectangle radius="roundedTop" fill="alabaster">
          <Typography component="div" color="black" preset="tag--large">
            <Space right="xsmall">
              <Icon name="wickets" color="black" size={18} topOffset={4} />
            </Space>
            <Trans i18nKey="teams:fall_of_wickets_title">Fall of wickets</Trans>
          </Typography>
        </Rectangle>
      </Cushion>
      {fow.map((wicket) => (
        <Rectangle key={wicket.wicket} fill="white" borderBottom="thinLightGrey">
          <Cushion
            all="small"
            left="medium"
            responsive={[{ maxWidth: 'tab', props: { left: 'small' } }]}
          >
            <Grid columns="60px 1fr" columnGap="medium">
              <Typography component="div" color="black" preset="subtitle--small">
                {`${wicket.teamScore}-${wicket.wicket}`}
              </Typography>
              <Typography component="div" color="dustygrey" preset="body--small" align="left">
                {wicket.batsmanName}
              </Typography>
            </Grid>
          </Cushion>
        </Rectangle>
      ))}
    </Shadow>
  </Space>
);

ScoreCardFallOfWickets.propTypes = {
  fow: PropTypes.arrayOf(
    PropTypes.shape({
      batsmanName: PropTypes.string.isRequired,
      teamScore: PropTypes.number.isRequired,
      wicket: PropTypes.number.isRequired,
    }),
  ).isRequired,
};

export default ScoreCardFallOfWickets;
